
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/writers/[userName]/[page]",
      function () {
        return require("private-next-pages/writers/[userName]/[page]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/writers/[userName]/[page]"])
      });
    }
  